module.exports = __webpack_public_path__ + "img/cartes-bancaires.39d7c528.png";